import { useState, useEffect } from 'react';
import type { TripDataType } from './models';
import { getSavedTrips, filterTripsInFuture, setLocalStorage } from './utils';

const useSaveTrips = () => {
  const [savedTrips, setSavedTrips] = useState<TripDataType[]>(getSavedTrips());

  const addSavedTrip = (tripData: TripDataType) => {
    const likedTrip = {
      ...tripData,
    };
    setSavedTrips((prevState) => [...prevState, likedTrip]);
  };

  const removeSavedTrip = (selectionKey: string) => {
    setSavedTrips((prevState) => prevState.filter((item) => item.selectionKey !== selectionKey));
  };

  useEffect(() => {
    const filteredTrips = filterTripsInFuture(savedTrips);
    setLocalStorage('savedTrips', filteredTrips);
  }, [savedTrips]);

  return { savedTrips, addSavedTrip, removeSavedTrip };
};

export default useSaveTrips;
